import styled, { css } from 'styled-components';
import { Link } from 'app/shared/ui';

import { media } from 'app/shared/styles_js/variables';
import { P2FixedSt } from 'app/shared/components/Typo/TextTemplates';

export const BreadcrumbContainerSt = styled.ol`
  display: none;
  padding-left: 0;
  margin: 0;
  list-style: none;

  ${media.md(css`
    display: block;
  `)};
`;

export const BreadcrumbItemSt = styled.li.attrs(
  /* istanbul ignore next */
  (props) => ({
    ...props,
  }),
)`
  display: inline;
`;

export const BreadcrumbLinkSt = styled(Link).attrs(
  /* istanbul ignore next */
  (props) => {
    const {
      theme: { colors },
    } = props;
    return {
      textDecoration: 'none',
      fontWeight: 'medium',
      /* istanbul ignore next */
      color: colors.micaBlue,
      /* istanbul ignore next */
      hoverColor: colors.actionBlue,
      ...props,
    };
  },
)`
  margin-right: 3px;
  ${P2FixedSt};

  &::after {
    content: ' ${({ separator }) => separator}';
  }

  ${({ disabled }) =>
    /* istanbul ignore next */
    disabled &&
    css`
      color: ${({ theme: { colors } }) => colors.tarmacGrey};

      &:hover {
        color: ${({ theme: { colors } }) => colors.tarmacGrey};

        cursor: default;
      }
    `};
`;

export const BreadcrumbItemDisabledSt = styled.li`
  display: inline;
`;

export const BreadcrumbDisabledSt = styled.div`
  display: inline-block;
  cursor: default;
  ${P2FixedSt};

  color: ${({ theme: { colors } }) => colors.tarmacGrey};

  ${({ lastItem, isCurrentPageHighlighted }) =>
    lastItem && lastItem
      ? isCurrentPageHighlighted &&
        css`
          font-weight: bold;
        `
      : css`
          margin-right: 3px;
          &::after {
            content: ' ${({ separator }) => separator}';
          }
        `};
`;
